import "vant/es/toast/style";
export default {
  name: "app"
};